import { ThreeDepartmentDashboardFilters, ThreeDepartmentDashboardTable } from "modules/ThreeDepartmentDashboard/components";

export const ThreeDepartmentDashboard = () => {
  return (
    <>
      <ThreeDepartmentDashboardFilters />
      <ThreeDepartmentDashboardTable />
    </>
  );
};
